import { encodeParam } from './urlCrypto'

export function isProductFamily(root) {
  return [root && root.categoryName, root && root.customTitle].some(name =>
    /^(productfamil(?:y|ies)|productfamliy|家族系列|产品家族|產品家族)$/i.test(String(name || '').replace(/\s+/g, ''))
  )
}

// Both navigation layouts must use the same category/series distinction.
export function productCategoryRoute(item, root, productsPath) {
  if (isProductFamily(root)) {
    return {
      path: `${productsPath}/detail`,
      query: {
        pid: encodeParam(item.id),
        product: item.categoryName,
        ...(item.seriesCategoryId != null ? { seriesCategoryId: item.seriesCategoryId } : {})
      }
    }
  }
  return {
    path: productsPath,
    query: { id: encodeParam(item.id), title: item.categoryName, search: item.categoryName }
  }
}
